export enum SortOrderEnum {
  DESC = 'DESC',
  ASC = 'ASC',
  DESC_LOWERCASE = 'desc',
  ASC_LOWERCASE = 'asc',
}
